import React, { useState } from 'react';


const GlobalContext = React.createContext([{}, () => {}]);

const GlobalProvider = props => {
    const [state, setState] = useState({
        cantidadReservas: 0,
        usuario: {}
    });

    const { children } = props;

    return (
        <GlobalContext.Provider value={[state, setState]}>
            {children}
        </GlobalContext.Provider>
    );
};

export { GlobalContext, GlobalProvider };



// WEBPACK FOOTER //
// ./src/context/globalContext.js